/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Origine dell\'allegato pratica (add-pratica-allegati, Fase 4.d.3)
 */
export enum OrigineAllegato {

    CITTADINO = 'CITTADINO',

    OPERATORE = 'OPERATORE',

    SISTEMA = 'SISTEMA',

    ESERCENTE = 'ESERCENTE'
}

